import axios from '@/libs/api.request'
import config from '@/config'

export const getpersonnellist = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/weixin/personnelapply/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const getpersonnelconfig = (page, limit, key, value) => {
  return axios.request({
    url: '/v1/weixin/personnelconfiglist/',
    method: 'get',
    params: {
      key,
      value,
      page,
      limit
    }
  })
}

export const operationpersonnelconfig = (data, meth) => {
  return axios.request({
    url: '/v1/weixin/personnelconfiglist/',
    method: meth,
    data
  })
}
